import {
  CREATE_PROJECT_INIT,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILED,
  GET_PROJECT_ANALYTICS_INIT,
  GET_PROJECT_ANALYTICS_SUCCESS,
  GET_PROJECT_ANALYTICS_FAILED,
  GET_NO_PROJECTS_BY_TYPE_INIT,
  GET_NO_PROJECTS_BY_TYPE_SUCCESS,
  GET_NO_PROJECTS_BY_TYPE_FAILED,
  GET_OVERALL_PROGRESS_INIT,
  GET_OVERALL_PROGRESS_SUCCESS,
  GET_OVERALL_PROGRESS_FAILED,
  GET_PROJECT_DETAILS_BY_ID_INIT,
  GET_PROJECT_DETAILS_BY_ID_SUCCESS,
  GET_PROJECT_DETAILS_BY_ID_FAILED,
  UPDATE_PROJECT_DETAILS_BY_ID_INIT,
  UPDATE_PROJECT_DETAILS_BY_ID_SUCCESS,
  UPDATE_PROJECT_DETAILS_BY_ID_FAILED,
  GET_PROJECT_KANBAN_VIEW_INIT,
  GET_PROJECT_KANBAN_VIEW_SUCCESS,
  GET_PROJECT_KANBAN_VIEW_FAILED,
  GET_PROJECT_KANBAN_RESOURCE_INIT,
  GET_PROJECT_KANBAN_RESOURCE_SUCCESS,
  GET_PROJECT_KANBAN_RESOURCE_FAILED,
  ADD_RESOURCE_INIT,
  ADD_RESOURCE_SUCCESS,
  ADD_RESOURCE_FAILED,
  REMOVE_RESOURCE_INIT,
  REMOVE_RESOURCE_SUCCESS,
  REMOVE_RESOURCE_FAILED,
  GET_ADD_RESOURCE_INIT,
  GET_ADD_RESOURCE_SUCCESS,
  GET_ADD_RESOURCE_FAILED,
  GET_PROJECTS_LIST_INIT,
  GET_PROJECTS_LIST_SUCCESS,
  GET_PROJECTS_LIST_FAILED,
  GET_RESOURCE_BY_ID_INIT,
  GET_RESOURCE_BY_ID_SUCCESS,
  GET_RESOURCE_BY_ID_FAILED,
  GET_PL_STATEMENT_BUDGET_INIT,
  GET_PL_STATEMENT_BUDGET_SUCCESS,
  GET_PL_STATEMENT_BUDGET_FAILED,
  GET_PL_STATEMENT_FORECAST_INIT,
  GET_PL_STATEMENT_FORECAST_SUCCESS,
  GET_PL_STATEMENT_FORECAST_FAILED,
  GET_BUDGET_FORECAST_INIT,
  GET_BUDGET_FORECAST_SUCCESS,
  GET_BUDGET_FORECAST_FAILED,
  GET_BREAKDOWN_CHART_INIT,
  GET_BREAKDOWN_CHART_SUCCESS,
  GET_BREAKDOWN_CHART_FAILED,
  GET_TOTAL_COST_INIT,
  GET_TOTAL_COST_SUCCESS,
  GET_TOTAL_COST_FAILED,
  GET_TOTAL_BUDGET_INIT,
  GET_TOTAL_BUDGET_SUCCESS,
  GET_TOTAL_BUDGET_FAILED,
  ADD_RESOURCE_REQUESTS_INIT,
  ADD_RESOURCE_REQUESTS_SUCCESS,
  ADD_RESOURCE_REQUESTS_FAILED,
  DOWNLOAD_PROJECT_ANALYTICS_INIT,
  DOWNLOAD_PROJECT_ANALYTICS_SUCCESS,
  DOWNLOAD_PROJECT_ANALYTICS_FAILED,
  GET_NAMED_RESOURCES_ALLOCATIONS_INIT,
  GET_NAMED_RESOURCES_ALLOCATIONS_SUCCESS,
  GET_NAMED_RESOURCES_ALLOCATIONS_FAILED,
  GET_UNNAMED_RESOURCES_ALLOCATIONS_INIT,
  GET_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS,
  GET_UNNAMED_RESOURCES_ALLOCATIONS_FAILED,
  UPDATE_NAMED_RESOURCES_ALLOCATIONS_INIT,
  UPDATE_NAMED_RESOURCES_ALLOCATIONS_SUCCESS,
  UPDATE_NAMED_RESOURCES_ALLOCATIONS_FAILED,
  UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_INIT,
  UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS,
  UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_FAILED,
  ADD_TO_PROJECT_NAMED_INIT,
  ADD_TO_PROJECT_NAMED_SUCCESS,
  ADD_TO_PROJECT_NAMED_FAILED,
  ADD_TO_PROJECT_UNNAMED_INIT,
  ADD_TO_PROJECT_UNNAMED_SUCCESS,
  ADD_TO_PROJECT_UNNAMED_FAILED,
  GET_REQUEST_RESOURCES_BY_FILTERS_INIT,
  GET_REQUEST_RESOURCES_BY_FILTERS_SUCCESS,
  GET_REQUEST_RESOURCES_BY_FILTERS_FAILED,
  GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_INIT,
  GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_SUCCESS,
  GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_FAILED,
  GET_DOWNLOAD_CREATE_PROJECT_INIT,
  GET_DOWNLOAD_CREATE_PROJECT_SUCCESS,
  GET_DOWNLOAD_CREATE_PROJECT_FAILED,
  CREATE_PROJECT_FROM_EXCEL_INIT,
  CREATE_PROJECT_FROM_EXCEL_SUCCESS,
  CREATE_PROJECT_FROM_EXCEL_FAILED,
  CLEAR_PM_LANDING_DATA,
  CLEAR_PM_DETAILS_DATA,
  CLEAR_PM_NAMED_DETAILS_DATA,
  CLEAR_PM_UNNAMED_DETAILS_DATA,
  UPDATE_FAVOURITE_STATUS_INIT,
  UPDATE_FAVOURITE_STATUS_SUCCESS,
  UPDATE_FAVOURITE_STATUS_FAILED,
  SHOW_NAMED_UNNAMED_BUTTON_INIT,
  SHOW_NAMED_UNNAMED_BUTTON_SUCCESS,
  SHOW_NAMED_UNNAMED_BUTTON_FAILED,
  COMPLIANCE_REPORT_PROJECT_INIT,
  COMPLIANCE_REPORT_PROJECT_SUCCESS,
  COMPLIANCE_REPORT_PROJECT_FAILED,
  DOWNLOAD_COMPLIANCE_REPORT_PROJECT_INIT,
  DOWNLOAD_COMPLIANCE_REPORT_PROJECT_SUCCESS,
  DOWNLOAD_COMPLIANCE_REPORT_PROJECT_FAILED,
  GET_ADMIN_SUPPORT_ACTIVITIES_INIT,
  GET_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
  GET_ADMIN_SUPPORT_ACTIVITIES_FAILED,
  UPDATE_ADMIN_SUPPORT_ACTIVITIES_INIT,
  UPDATE_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
  UPDATE_ADMIN_SUPPORT_ACTIVITIES_FAILED,
  DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_INIT,
  DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
  DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_FAILED,
  UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_INIT,
  UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_SUCCESS,
  UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_FAILED,
  ACCEPT_PROJECT_REQUEST_INIT,
  ACCEPT_PROJECT_REQUEST_SUCCESS,
  ACCEPT_PROJECT_REQUEST_FAILED,
  GET_NAMED_ALLOCATIONS_BY_MAPID_INIT,
  GET_NAMED_ALLOCATIONS_BY_MAPIDT_SUCCESS,
  GET_NAMED_ALLOCATIONS_BY_MAPID_FAILED,
  DOWNLOAD_FILTERED_PROJECT_ANALYTICS_INIT,
  DOWNLOAD_FILTERED_PROJECT_ANALYTICS_SUCCESS,
  DOWNLOAD_FILTERED_PROJECT_ANALYTICS_FAILED,
  DOWNLOAD_PROJECT_RESOURCE_DATA_INIT,
  DOWNLOAD_PROJECT_RESOURCE_DATA_SUCCESS,
  DOWNLOAD_PROJECT_RESOURCE_DATA_FAILED,
} from "../actions/types/project-management-types";

export const initialState = {
  createProjectData: 0,
  loadingAPI: true,
  projectAnalyticsData: [],
  noOfProjectsData: [],
  overAllProgressData: [],
  projectDetailsByIDData: [],
  updateProjectDetailsByIDData: 0,
  kanbanViewData: [],
  getKanbanResourceData: [],
  addResource: 0,
  removeResource: 0,
  getAddResourceData: [],
  projectsListData: [],
  getResourceByIdData: [],
  plStatementBudgetData: [],
  plStatementForecastData: [],
  budgetVsForecast: [],
  breakdownChart: [],
  totalCost: [],
  totalBudget: [],
  projectAnalyticsDownloadedData: "",
  namedResourcesAllocationsData: [],
  unnamedResourcesAllocationsData: [],
  updatedNamedResourcesAllocationsData: "",
  updatedUnnamedResourcesAllocationsData: "",
  addToProjectNamedData: "",
  addToProjectUnnamedData: "",
  requestResourcesByFiltersData: [],
  requestResourcesByFiltersByRMData: [],
  downloadCreateProjectExcelFile: "",
  createProjectFromExcel: [],
  updateFavouriteData: [],
  showAddNamedUnamedButtonsData: [],
  downdloadComplianceReportProjectData: "",
  complianceReportProjectData: [],
  adminSupportActivityData: [],
  updateAdminSupportActivityData: [],
  downloadAdminSupportActivityData: "",
  updateAdminSupportResourceActivityData: [],
  namedAllocationsByMapIDData: [],
  acceptRequestProjectData: "",
  downloadFilteredProjectAnalysisData: "",
  downloadProjectResourceData: "",
};

const handlers = {
  [CREATE_PROJECT_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [CREATE_PROJECT_SUCCESS]: (state, action) => ({
    ...state,
    createProjectData: action.response,
    loadingAPI: false,
  }),
  [CREATE_PROJECT_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_PROJECT_ANALYTICS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_PROJECT_ANALYTICS_SUCCESS]: (state, action) => ({
    ...state,
    projectAnalyticsData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_ANALYTICS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_NO_PROJECTS_BY_TYPE_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_NO_PROJECTS_BY_TYPE_SUCCESS]: (state, action) => ({
    ...state,
    noOfProjectsData: action.response,
    loadingAPI: false,
  }),
  [GET_NO_PROJECTS_BY_TYPE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_OVERALL_PROGRESS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_OVERALL_PROGRESS_SUCCESS]: (state, action) => ({
    ...state,
    overAllProgressData: action.response,
    loadingAPI: false,
  }),
  [GET_OVERALL_PROGRESS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_PROJECT_DETAILS_BY_ID_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_PROJECT_DETAILS_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    projectDetailsByIDData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_DETAILS_BY_ID_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_PROJECT_DETAILS_BY_ID_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_PROJECT_DETAILS_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    updateProjectDetailsByIDData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_PROJECT_DETAILS_BY_ID_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_PROJECT_KANBAN_VIEW_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PROJECT_KANBAN_VIEW_SUCCESS]: (state, action) => ({
    ...state,
    kanbanViewData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_KANBAN_VIEW_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_PROJECT_KANBAN_RESOURCE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PROJECT_KANBAN_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    getKanbanResourceData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_KANBAN_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ADD_RESOURCE_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [ADD_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    addResource: action.response,
    loadingAPI: false,
  }),
  [ADD_RESOURCE_FAILED]: (state) => ({ ...state, loadingAPI: false }),
  [ADD_RESOURCE_REQUESTS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [ADD_RESOURCE_REQUESTS_SUCCESS]: (state, action) => ({
    ...state,
    addResourceRequests: action.response,
    loadingAPI: false,
  }),
  [ADD_RESOURCE_REQUESTS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [REMOVE_RESOURCE_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [REMOVE_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    removeResource: action.response,
    loadingAPI: false,
  }),
  [REMOVE_RESOURCE_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_ADD_RESOURCE_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_ADD_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    getAddResourceData: action.response,
    loadingAPI: false,
  }),
  [GET_ADD_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_PROJECTS_LIST_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_PROJECTS_LIST_SUCCESS]: (state, action) => ({
    ...state,
    projectsListData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECTS_LIST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RESOURCE_BY_ID_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_RESOURCE_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    getResourceByIdData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCE_BY_ID_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_PL_STATEMENT_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PL_STATEMENT_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    plStatementBudgetData: action.response,
    loadingAPI: false,
  }),
  [GET_PL_STATEMENT_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_PL_STATEMENT_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PL_STATEMENT_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    plStatementForecastData: action.response,
    loadingAPI: false,
  }),
  [GET_PL_STATEMENT_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_BUDGET_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_BUDGET_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    budgetVsForecast: action.response,
    loadingAPI: false,
  }),
  [GET_BUDGET_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_BREAKDOWN_CHART_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_BREAKDOWN_CHART_SUCCESS]: (state, action) => ({
    ...state,
    breakdownChart: action.response,
    loadingAPI: false,
  }),
  [GET_BREAKDOWN_CHART_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_TOTAL_COST_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_TOTAL_COST_SUCCESS]: (state, action) => ({
    ...state,
    totalCost: action.response,
    loadingAPI: false,
  }),
  [GET_TOTAL_COST_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_TOTAL_BUDGET_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_TOTAL_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    totalBudget: action.response,
    loadingAPI: false,
  }),
  [GET_TOTAL_BUDGET_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [DOWNLOAD_PROJECT_ANALYTICS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [DOWNLOAD_PROJECT_ANALYTICS_SUCCESS]: (state, action) => ({
    ...state,
    projectAnalyticsDownloadedData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_PROJECT_ANALYTICS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_NAMED_RESOURCES_ALLOCATIONS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_NAMED_RESOURCES_ALLOCATIONS_SUCCESS]: (state, action) => ({
    ...state,
    namedResourcesAllocationsData: action.response,
    loadingAPI: false,
  }),
  [GET_NAMED_RESOURCES_ALLOCATIONS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_UNNAMED_RESOURCES_ALLOCATIONS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS]: (state, action) => ({
    ...state,
    unnamedResourcesAllocationsData: action.response,
    loadingAPI: false,
  }),
  [GET_UNNAMED_RESOURCES_ALLOCATIONS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_NAMED_RESOURCES_ALLOCATIONS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_NAMED_RESOURCES_ALLOCATIONS_SUCCESS]: (state, action) => ({
    ...state,
    updatedNamedResourcesAllocationsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_NAMED_RESOURCES_ALLOCATIONS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS]: (state, action) => ({
    ...state,
    updatedUnnamedResourcesAllocationsData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ADD_TO_PROJECT_NAMED_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [ADD_TO_PROJECT_NAMED_SUCCESS]: (state, action) => ({
    ...state,
    addToProjectNamedData: action.response,
    loadingAPI: false,
  }),
  [ADD_TO_PROJECT_NAMED_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ADD_TO_PROJECT_UNNAMED_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [ADD_TO_PROJECT_UNNAMED_SUCCESS]: (state, action) => ({
    ...state,
    addToProjectUnnamedData: action.response,
    loadingAPI: false,
  }),
  [ADD_TO_PROJECT_UNNAMED_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_REQUEST_RESOURCES_BY_FILTERS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_REQUEST_RESOURCES_BY_FILTERS_SUCCESS]: (state, action) => ({
    ...state,
    requestResourcesByFiltersData: action.response,
    loadingAPI: false,
  }),
  [GET_REQUEST_RESOURCES_BY_FILTERS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_SUCCESS]: (state, action) => ({
    ...state,
    requestResourcesByFiltersByRMData: action.response,
    loadingAPI: false,
  }),
  [GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DOWNLOAD_CREATE_PROJECT_INIT]: (state) => ({
    ...state,
    downloadCreateProjectExcelFile: "",
    loadingAPI: true,
  }),
  [GET_DOWNLOAD_CREATE_PROJECT_SUCCESS]: (state, action) => ({
    ...state,
    downloadCreateProjectExcelFile: action.response,
    loadingAPI: false,
  }),
  [GET_DOWNLOAD_CREATE_PROJECT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CREATE_PROJECT_FROM_EXCEL_INIT]: (state) => ({
    ...state,
    createProjectFromExcel: [],
    loadingAPI: true,
  }),
  [CREATE_PROJECT_FROM_EXCEL_SUCCESS]: (state, action) => ({
    ...state,
    createProjectFromExcel: action.response,
    loadingAPI: false,
  }),
  [CREATE_PROJECT_FROM_EXCEL_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CLEAR_PM_LANDING_DATA]: (state) => ({
    ...state,
    overAllProgressData: [],
    noOfProjectsData: [],
    projectAnalyticsData: [],
    loadingAPI: true,
  }),
  [CLEAR_PM_DETAILS_DATA]: (state) => ({
    ...state,
    projectDetailsByIDData: [],
    namedResourcesAllocationsData: [],
    unnamedResourcesAllocationsData: [],
    loadingAPI: true,
  }),
  [CLEAR_PM_NAMED_DETAILS_DATA]: (state) => ({
    ...state,
    namedResourcesAllocationsData: [],
    loadingAPI: true,
  }),
  [CLEAR_PM_UNNAMED_DETAILS_DATA]: (state) => ({
    ...state,
    unnamedResourcesAllocationsData: [],
    loadingAPI: true,
  }),

  [UPDATE_FAVOURITE_STATUS_INIT]: (state) => ({
    ...state,
    updateFavouriteData: [],
    loadingAPI: true,
  }),
  [UPDATE_FAVOURITE_STATUS_SUCCESS]: (state, action) => ({
    ...state,
    updateFavouriteData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_FAVOURITE_STATUS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [SHOW_NAMED_UNNAMED_BUTTON_INIT]: (state) => ({
    ...state,
    showAddNamedUnamedButtonsData: [],
    loadingAPI: true,
  }),
  [SHOW_NAMED_UNNAMED_BUTTON_SUCCESS]: (state, action) => ({
    ...state,
    showAddNamedUnamedButtonsData: action.response,
    loadingAPI: false,
  }),
  [SHOW_NAMED_UNNAMED_BUTTON_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_COMPLIANCE_REPORT_PROJECT_INIT]: (state) => ({
    ...state,
    downdloadComplianceReportProjectData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_COMPLIANCE_REPORT_PROJECT_SUCCESS]: (state, action) => ({
    ...state,
    downdloadComplianceReportProjectData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_COMPLIANCE_REPORT_PROJECT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [COMPLIANCE_REPORT_PROJECT_INIT]: (state) => ({
    ...state,
    complianceReportProjectData: [],
    loadingAPI: true,
  }),
  [COMPLIANCE_REPORT_PROJECT_SUCCESS]: (state, action) => ({
    ...state,
    complianceReportProjectData: action.response,
    loadingAPI: false,
  }),
  [COMPLIANCE_REPORT_PROJECT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_ADMIN_SUPPORT_ACTIVITIES_INIT]: (state) => ({
    ...state,
    adminSupportActivityData: [],
    loadingAPI: true,
  }),
  [GET_ADMIN_SUPPORT_ACTIVITIES_SUCCESS]: (state, action) => ({
    ...state,
    adminSupportActivityData: action.response,
    loadingAPI: false,
  }),
  [GET_ADMIN_SUPPORT_ACTIVITIES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_ADMIN_SUPPORT_ACTIVITIES_INIT]: (state) => ({
    ...state,
    updateAdminSupportActivityData: [],
    loadingAPI: true,
  }),
  [UPDATE_ADMIN_SUPPORT_ACTIVITIES_SUCCESS]: (state, action) => ({
    ...state,
    updateAdminSupportActivityData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_ADMIN_SUPPORT_ACTIVITIES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_INIT]: (state) => ({
    ...state,
    downloadAdminSupportActivityData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_SUCCESS]: (state, action) => ({
    ...state,
    downloadAdminSupportActivityData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_INIT]: (state) => ({
    ...state,
    updateAdminSupportResourceActivityData: [],
    loadingAPI: true,
  }),
  [UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_SUCCESS]: (state, action) => ({
    ...state,
    updateAdminSupportResourceActivityData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_NAMED_ALLOCATIONS_BY_MAPID_INIT]: (state) => ({
    ...state,
    namedAllocationsByMapIDData: [],
    loadingAPI: true,
  }),
  [GET_NAMED_ALLOCATIONS_BY_MAPIDT_SUCCESS]: (state, action) => ({
    ...state,
    namedAllocationsByMapIDData: action.response,
    loadingAPI: false,
  }),
  [GET_NAMED_ALLOCATIONS_BY_MAPID_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ACCEPT_PROJECT_REQUEST_INIT]: (state) => ({
    ...state,
    acceptRequestProjectData: "",
    loadingAPI: true,
  }),
  [ACCEPT_PROJECT_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    acceptRequestProjectData: action.response,
    loadingAPI: false,
  }),
  [ACCEPT_PROJECT_REQUEST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_FILTERED_PROJECT_ANALYTICS_INIT]: (state) => ({
    ...state,
    downloadFilteredProjectAnalysisData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_FILTERED_PROJECT_ANALYTICS_SUCCESS]: (state, action) => ({
    ...state,
    downloadFilteredProjectAnalysisData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_FILTERED_PROJECT_ANALYTICS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_PROJECT_RESOURCE_DATA_INIT]: (state) => ({
    ...state,
    downloadProjectResourceData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_PROJECT_RESOURCE_DATA_SUCCESS]: (state, action) => ({
    ...state,
    downloadProjectResourceData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_PROJECT_RESOURCE_DATA_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
};

export default function projectManagementReducer(state = initialState, action) {
  const handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
}
